import QRCode from 'qrcode-generator';

export const QR_CONFIG = {
  size: 160,
  cellSize: 4,
  markerSize: 7,
  fgColor: '#626F59',
  bgColor: 'transparent',
};

export const createQRCode = (data: string) => {
  const qr = QRCode(0, 'H');
  qr.addData(data);
  qr.make();
  return qr;
};

export const generateSVGWrapper = (content: string, size: number) => {
  return `
    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
      <rect width="${size}" height="${size}" fill="${QR_CONFIG.bgColor}"/>
      ${content}
    </svg>
  `;
};

export const isPositionMarker = (row: number, col: number, modules: number) => {
  const { markerSize } = QR_CONFIG;

  return (
    (row < markerSize && col < markerSize) ||
    (row < markerSize && col >= modules - markerSize) ||
    (row >= modules - markerSize && col < markerSize)
  );
};

export const generateDataModules = (
  qr: any,
  cellSize: number,
  modules: number
) => {
  let svg = '';

  for (let row = 0; row < modules; row++) {
    for (let col = 0; col < modules; col++) {
      if (qr.isDark(row, col) && !isPositionMarker(row, col, modules)) {
        const x = col * cellSize;
        const y = row * cellSize;
        svg += `<rect x="${x}" y="${y}" width="${cellSize}" height="${cellSize}" fill="${QR_CONFIG.fgColor}"/>`;
      }
    }
  }

  return svg;
};

export const generateSingleMarker = (
  markerX: number,
  markerY: number,
  cellSize: number
) => {
  const { markerSize, fgColor } = QR_CONFIG;

  const outerRect = `<rect x="${markerX}" y="${markerY}" width="${markerSize * cellSize}" height="${markerSize * cellSize}" fill="${fgColor}" rx="10" ry="10"/>`;

  const innerSize = 4.5 * cellSize;
  const innerOffset = 1.25 * cellSize;
  const innerRect = `<rect x="${markerX + innerOffset}" y="${markerY + innerOffset}" width="${innerSize}" height="${innerSize}" fill="white" rx="4" ry="4"/>`;

  const centerSize = 2.5 * cellSize;
  const centerOffset = 2.25 * cellSize;
  const centerRect = `<rect x="${markerX + centerOffset}" y="${markerY + centerOffset}" width="${centerSize}" height="${centerSize}" fill="${fgColor}" rx="3" ry="3"/>`;

  return outerRect + innerRect + centerRect;
};

export const generateRoundedMarkers = (cellSize: number, modules: number) => {
  const { markerSize } = QR_CONFIG;

  const markers = [
    { row: 0, col: 0 },
    { row: 0, col: modules - markerSize },
    { row: modules - markerSize, col: 0 },
  ];

  return markers
    .map(marker => {
      const markerX = marker.col * cellSize;
      const markerY = marker.row * cellSize;
      return generateSingleMarker(markerX, markerY, cellSize);
    })
    .join('');
};

export const generateCustomQRCode = (data: string) => {
  const qr = createQRCode(data);
  const { size } = QR_CONFIG;
  const modules = qr.getModuleCount();

  const cellSize = size / modules;

  const dataModules = generateDataModules(qr, cellSize, modules);
  const markers = generateRoundedMarkers(cellSize, modules);

  return generateSVGWrapper(dataModules + markers, size);
};
